import {Notification} from 'element-ui';
import AxiosUtils from '@/utils/axios'
import store from '@/store/index'
import Mutations from "@/constants/store/mutations";
import qs from 'qs'

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.interceptors.request.use(
    (config) => {
        config.paramsSerializer = (params) => qs.stringify(params, {arrayFormat: 'brackets'})
        return config
    }
)
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    let status = _.get(error, 'response.status');
    let message = _.get(error, 'response.data.error_message');

    switch (status) {
        case 401:
            // todo: to be implemented
            window.location = '/';
            break;
        case 403:
            if (!message) {
                message = 'Your action is forbidden.';
            }
            Notification.error({
                title: 'Whoops!',
                message,
                duration: 0,
                dangerouslyUseHTMLString: true,
            });
            break;
        case 419:
            return AxiosUtils.refreshTokens()
                .then(token => {
                    error.config.headers['X-CSRF-TOKEN'] = token;
                    store.commit(Mutations.set_csrf, token);
                    return axios.request(error.config)
                });
        case 500:
            const {
                config: { support_email },
            } = window.App.state

            Notification.error({
                title: 'Whoops!',
                message: `Something went wrong. <br/>Please email <a href="mailto:${support_email}">${support_email}</a>.`,
                duration: 0,
                dangerouslyUseHTMLString: true,
            });
            break;
    }
    return Promise.reject(error);
});
